"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QrGeneratorFrameTypes = exports.QrGeneratorSocialMediaBannerStyles = exports.QrGeneratorFacilityTypes = exports.SocialsInterfaceTypes = exports.AppStores = exports.Allergens = exports.DaysOfTheWeek = exports.QrCodeTypes = exports.QrGeneratorUpdateModes = exports.QrGeneratorNavigatorStaticCategories = exports.QrGeneratorNavigatorDynamicCategories = exports.BitcoinTypes = exports.WiFiEncryptionTypes = exports.QrThemeQrStyleQROptionsErrorCorrectionalLevels = exports.QrThemeQrStyleQROptionsModes = exports.QrThemeQrStyleImageCrossOriginOptions = exports.QrThemeCornerOptions = exports.QrThemeGradientTypes = exports.QrRecordTypes = exports.QRLogoSlugs = exports.DynamicQrPageThemeType = exports.QrGeneratorNavigatorCategories = void 0;
var QrGeneratorNavigatorCategories;
(function (QrGeneratorNavigatorCategories) {
    QrGeneratorNavigatorCategories["URL"] = "url";
    QrGeneratorNavigatorCategories["SMS"] = "sms";
    QrGeneratorNavigatorCategories["APP"] = "app";
    QrGeneratorNavigatorCategories["MP3"] = "mp3";
    QrGeneratorNavigatorCategories["PDF"] = "pdf";
    QrGeneratorNavigatorCategories["PET"] = "pet";
    QrGeneratorNavigatorCategories["TEXT"] = "text";
    QrGeneratorNavigatorCategories["WIFI"] = "wifi";
    QrGeneratorNavigatorCategories["VCARD"] = "vcard";
    QrGeneratorNavigatorCategories["EMAIL"] = "email";
    QrGeneratorNavigatorCategories["EVENT"] = "event";
    QrGeneratorNavigatorCategories["IMAGES"] = "images";
    QrGeneratorNavigatorCategories["VIDEOS"] = "videos";
    QrGeneratorNavigatorCategories["RATING"] = "rating";
    QrGeneratorNavigatorCategories["WEBSITE"] = "website";
    QrGeneratorNavigatorCategories["VACANCY"] = "vacancy";
    QrGeneratorNavigatorCategories["COUPONS"] = "coupons";
    QrGeneratorNavigatorCategories["BITCOIN"] = "bitcoin";
    QrGeneratorNavigatorCategories["LOCATION"] = "location";
    QrGeneratorNavigatorCategories["MEMORIES"] = "memories";
    QrGeneratorNavigatorCategories["FEEDBACK"] = "feedback";
    QrGeneratorNavigatorCategories["VCARD_PRO"] = "vcard-pro";
    QrGeneratorNavigatorCategories["SOCIAL_MEDIA"] = "social-media";
    QrGeneratorNavigatorCategories["LOCATION_PLUS"] = "location-plus";
    QrGeneratorNavigatorCategories["BUSINESS_PAGE"] = "business-page";
    QrGeneratorNavigatorCategories["LONG_PLAIN_TEXT"] = "long-plain-text";
    QrGeneratorNavigatorCategories["RESTAURANT_MENU"] = "restaurant-menu";
})(QrGeneratorNavigatorCategories = exports.QrGeneratorNavigatorCategories || (exports.QrGeneratorNavigatorCategories = {}));
var DynamicQrPageThemeType;
(function (DynamicQrPageThemeType) {
    DynamicQrPageThemeType["ThemeType1"] = "ThemeType1";
    DynamicQrPageThemeType["ThemeType2"] = "ThemeType2";
    DynamicQrPageThemeType["ThemeType3"] = "ThemeType3";
    DynamicQrPageThemeType["ThemeType4"] = "ThemeType4";
    DynamicQrPageThemeType["ThemeType5"] = "ThemeType5";
    DynamicQrPageThemeType["ThemeType6"] = "ThemeType6";
    DynamicQrPageThemeType["ThemeType7"] = "ThemeType7";
    DynamicQrPageThemeType["ThemeType8"] = "ThemeType8";
    DynamicQrPageThemeType["ThemeType9"] = "ThemeType9";
    DynamicQrPageThemeType["ThemeType10"] = "ThemeType10";
    DynamicQrPageThemeType["ThemeType11"] = "ThemeType11";
    DynamicQrPageThemeType["ThemeType12"] = "ThemeType12";
    DynamicQrPageThemeType["ThemeType13"] = "ThemeType13";
    DynamicQrPageThemeType["ThemeType14"] = "ThemeType14";
    DynamicQrPageThemeType["ThemeType15"] = "ThemeType15";
    DynamicQrPageThemeType["ThemeType16"] = "ThemeType16";
    DynamicQrPageThemeType["ThemeType17"] = "ThemeType17";
    DynamicQrPageThemeType["ThemeType18"] = "ThemeType18";
})(DynamicQrPageThemeType = exports.DynamicQrPageThemeType || (exports.DynamicQrPageThemeType = {}));
var QRLogoSlugs;
(function (QRLogoSlugs) {
    QRLogoSlugs["COUPON"] = "coupon";
    QRLogoSlugs["DEFAULT"] = "default";
    QRLogoSlugs["SCAN_ME"] = "scan-me";
    QRLogoSlugs["INFO"] = "info";
    QRLogoSlugs["LIKE"] = "like";
    QRLogoSlugs["PAYPAL"] = "paypal";
    QRLogoSlugs["TWITTER"] = "twitter";
    QRLogoSlugs["FACEBOOK"] = "facebook";
    QRLogoSlugs["LINKEDIN"] = "linkedin";
    QRLogoSlugs["INSTAGRAM"] = "instagram";
})(QRLogoSlugs = exports.QRLogoSlugs || (exports.QRLogoSlugs = {}));
var QrRecordTypes;
(function (QrRecordTypes) {
    QrRecordTypes["QRCODE"] = "qr_code";
    QrRecordTypes["QRVISIT"] = "qr_visit";
    QrRecordTypes["QRASSET"] = "qr_asset";
    QrRecordTypes["QRRESPONSE"] = "qr_responses";
    QrRecordTypes["QROFFTHESHELF"] = "qr_off_the_shelf";
    QrRecordTypes["QRSTYLETEMPLATE"] = "qr_style_template";
})(QrRecordTypes = exports.QrRecordTypes || (exports.QrRecordTypes = {}));
var QrThemeGradientTypes;
(function (QrThemeGradientTypes) {
    QrThemeGradientTypes["LINEAR"] = "linear";
    QrThemeGradientTypes["RADIAL"] = "radial";
})(QrThemeGradientTypes = exports.QrThemeGradientTypes || (exports.QrThemeGradientTypes = {}));
var QrThemeCornerOptions;
(function (QrThemeCornerOptions) {
    QrThemeCornerOptions["DOT"] = "dot";
    QrThemeCornerOptions["DOTS"] = "dots";
    QrThemeCornerOptions["SQUARE"] = "square";
    QrThemeCornerOptions["CLASSY"] = "classy";
    QrThemeCornerOptions["ROUNDED"] = "rounded";
    QrThemeCornerOptions["EXTRA_ROUNDED"] = "extra-rounded";
    QrThemeCornerOptions["CLASSY_ROUNDED"] = "classy-rounded";
})(QrThemeCornerOptions = exports.QrThemeCornerOptions || (exports.QrThemeCornerOptions = {}));
var QrThemeQrStyleImageCrossOriginOptions;
(function (QrThemeQrStyleImageCrossOriginOptions) {
    QrThemeQrStyleImageCrossOriginOptions["ANONYMOUS"] = "anonymous";
    QrThemeQrStyleImageCrossOriginOptions["USE_CREDENTIALS"] = "use-credentials";
})(QrThemeQrStyleImageCrossOriginOptions = exports.QrThemeQrStyleImageCrossOriginOptions || (exports.QrThemeQrStyleImageCrossOriginOptions = {}));
var QrThemeQrStyleQROptionsModes;
(function (QrThemeQrStyleQROptionsModes) {
    QrThemeQrStyleQROptionsModes["Byte"] = "Byte";
    QrThemeQrStyleQROptionsModes["Kanji"] = "Kanji";
    QrThemeQrStyleQROptionsModes["Numeric"] = "Numeric";
    QrThemeQrStyleQROptionsModes["Alphanumeric"] = "Alphanumeric";
})(QrThemeQrStyleQROptionsModes = exports.QrThemeQrStyleQROptionsModes || (exports.QrThemeQrStyleQROptionsModes = {}));
var QrThemeQrStyleQROptionsErrorCorrectionalLevels;
(function (QrThemeQrStyleQROptionsErrorCorrectionalLevels) {
    QrThemeQrStyleQROptionsErrorCorrectionalLevels["L"] = "L";
    QrThemeQrStyleQROptionsErrorCorrectionalLevels["M"] = "M";
    QrThemeQrStyleQROptionsErrorCorrectionalLevels["Q"] = "Q";
    QrThemeQrStyleQROptionsErrorCorrectionalLevels["H"] = "H";
})(QrThemeQrStyleQROptionsErrorCorrectionalLevels = exports.QrThemeQrStyleQROptionsErrorCorrectionalLevels || (exports.QrThemeQrStyleQROptionsErrorCorrectionalLevels = {}));
var WiFiEncryptionTypes;
(function (WiFiEncryptionTypes) {
    WiFiEncryptionTypes["WPA"] = "WPA";
    WiFiEncryptionTypes["WEP"] = "WEP";
    WiFiEncryptionTypes["NONE"] = "nopass";
})(WiFiEncryptionTypes = exports.WiFiEncryptionTypes || (exports.WiFiEncryptionTypes = {}));
var BitcoinTypes;
(function (BitcoinTypes) {
    BitcoinTypes["DASH"] = "dash";
    BitcoinTypes["BITCOIN"] = "bitcoin";
    BitcoinTypes["ETHEREUM"] = "ethereum";
    BitcoinTypes["LITECOIN"] = "litecoin";
    BitcoinTypes["BITCOINCASH"] = "bitcoincash";
})(BitcoinTypes = exports.BitcoinTypes || (exports.BitcoinTypes = {}));
var QrGeneratorNavigatorDynamicCategories;
(function (QrGeneratorNavigatorDynamicCategories) {
    QrGeneratorNavigatorDynamicCategories["APP"] = "app";
    QrGeneratorNavigatorDynamicCategories["MP3"] = "mp3";
    QrGeneratorNavigatorDynamicCategories["PDF"] = "pdf";
    QrGeneratorNavigatorDynamicCategories["PET"] = "pet";
    QrGeneratorNavigatorDynamicCategories["EVENT"] = "event";
    QrGeneratorNavigatorDynamicCategories["IMAGES"] = "images";
    QrGeneratorNavigatorDynamicCategories["VIDEOS"] = "videos";
    QrGeneratorNavigatorDynamicCategories["RATING"] = "rating";
    QrGeneratorNavigatorDynamicCategories["WEBSITE"] = "website";
    QrGeneratorNavigatorDynamicCategories["VACANCY"] = "vacancy";
    QrGeneratorNavigatorDynamicCategories["COUPONS"] = "coupons";
    QrGeneratorNavigatorDynamicCategories["FEEDBACK"] = "feedback";
    QrGeneratorNavigatorDynamicCategories["MEMORIES"] = "memories";
    QrGeneratorNavigatorDynamicCategories["VCARD_PRO"] = "vcard-pro";
    QrGeneratorNavigatorDynamicCategories["SOCIAL_MEDIA"] = "social-media";
    QrGeneratorNavigatorDynamicCategories["LOCATION_PLUS"] = "location-plus";
    QrGeneratorNavigatorDynamicCategories["BUSINESS_PAGE"] = "business-page";
    QrGeneratorNavigatorDynamicCategories["RESTAURANT_MENU"] = "restaurant-menu";
    QrGeneratorNavigatorDynamicCategories["LONG_PLAIN_TEXT"] = "long-plain-text";
})(QrGeneratorNavigatorDynamicCategories = exports.QrGeneratorNavigatorDynamicCategories || (exports.QrGeneratorNavigatorDynamicCategories = {}));
var QrGeneratorNavigatorStaticCategories;
(function (QrGeneratorNavigatorStaticCategories) {
    QrGeneratorNavigatorStaticCategories["URL"] = "url";
    QrGeneratorNavigatorStaticCategories["SMS"] = "sms";
    QrGeneratorNavigatorStaticCategories["TEXT"] = "text";
    QrGeneratorNavigatorStaticCategories["WIFI"] = "wifi";
    QrGeneratorNavigatorStaticCategories["VCARD"] = "vcard";
    QrGeneratorNavigatorStaticCategories["EMAIL"] = "email";
    QrGeneratorNavigatorStaticCategories["BITCOIN"] = "bitcoin";
    QrGeneratorNavigatorStaticCategories["LOCATION"] = "location";
})(QrGeneratorNavigatorStaticCategories = exports.QrGeneratorNavigatorStaticCategories || (exports.QrGeneratorNavigatorStaticCategories = {}));
var QrGeneratorUpdateModes;
(function (QrGeneratorUpdateModes) {
    QrGeneratorUpdateModes["POPUP"] = "popup";
    QrGeneratorUpdateModes["QR_URL"] = "qr-url";
    QrGeneratorUpdateModes["STATUS"] = "status";
    QrGeneratorUpdateModes["SHORT_ID"] = "short-id";
    QrGeneratorUpdateModes["UNSETPOPUP"] = "unset-popup";
    QrGeneratorUpdateModes["DESCRIPTION"] = "description";
    QrGeneratorUpdateModes["DELETE_ASSET"] = "delete-asset";
    QrGeneratorUpdateModes["SUCCESS_POPUP"] = "success-popup";
    QrGeneratorUpdateModes["UNSET_SUCCESS_POPUP"] = "unset-success-popup";
})(QrGeneratorUpdateModes = exports.QrGeneratorUpdateModes || (exports.QrGeneratorUpdateModes = {}));
var QrCodeTypes;
(function (QrCodeTypes) {
    QrCodeTypes["STATIC"] = "static";
    QrCodeTypes["DYNAMIC"] = "dynamic";
})(QrCodeTypes = exports.QrCodeTypes || (exports.QrCodeTypes = {}));
var DaysOfTheWeek;
(function (DaysOfTheWeek) {
    DaysOfTheWeek["Sunday"] = "Sunday";
    DaysOfTheWeek["Monday"] = "Monday";
    DaysOfTheWeek["Tuesday"] = "Tuesday";
    DaysOfTheWeek["Wednesday"] = "Wednesday";
    DaysOfTheWeek["Thursday"] = "Thursday";
    DaysOfTheWeek["Friday"] = "Friday";
    DaysOfTheWeek["Saturday"] = "Saturday";
})(DaysOfTheWeek = exports.DaysOfTheWeek || (exports.DaysOfTheWeek = {}));
var Allergens;
(function (Allergens) {
    Allergens["Nut"] = "Nut";
    Allergens["Egg"] = "Egg";
    Allergens["Oats"] = "Oats";
    Allergens["Fish"] = "Fish";
    Allergens["Soya"] = "Soya";
    Allergens["Milk"] = "Milk";
    Allergens["Wheat"] = "Wheat";
    Allergens["Gluten"] = "Gluten";
    Allergens["Sesame"] = "Sesame";
    Allergens["Celery"] = "Celery";
    Allergens["Walnut"] = "Walnut";
    Allergens["Tomato"] = "Tomato";
    Allergens["Cashews"] = "Cashews";
    Allergens["Peanuts"] = "Peanuts";
    Allergens["Mustard"] = "Mustard";
    Allergens["Molluscs"] = "Molluscs";
    Allergens["BrazilNuts"] = "BrazilNuts";
    Allergens["Crustaceans"] = "Crustaceans";
})(Allergens = exports.Allergens || (exports.Allergens = {}));
var AppStores;
(function (AppStores) {
    AppStores["AMAZON"] = "amazon";
    AppStores["APPSTORE"] = "appstore";
    AppStores["GOOGLEPLAY"] = "googleplay";
})(AppStores = exports.AppStores || (exports.AppStores = {}));
var SocialsInterfaceTypes;
(function (SocialsInterfaceTypes) {
    SocialsInterfaceTypes["mail"] = "mail";
    SocialsInterfaceTypes["tiktok"] = "tiktok";
    SocialsInterfaceTypes["twitter"] = "twitter";
    SocialsInterfaceTypes["website"] = "website";
    SocialsInterfaceTypes["youtube"] = "youtube";
    SocialsInterfaceTypes["facebook"] = "facebook";
    SocialsInterfaceTypes["linkedin"] = "linkedin";
    SocialsInterfaceTypes["onlyfans"] = "onlyfans";
    SocialsInterfaceTypes["whatsapp"] = "whatsapp";
    SocialsInterfaceTypes["pinterest"] = "pinterest";
    SocialsInterfaceTypes["instagram"] = "instagram";
})(SocialsInterfaceTypes = exports.SocialsInterfaceTypes || (exports.SocialsInterfaceTypes = {}));
var QrGeneratorFacilityTypes;
(function (QrGeneratorFacilityTypes) {
    QrGeneratorFacilityTypes["bar"] = "bar";
    QrGeneratorFacilityTypes["wifi"] = "wifi";
    QrGeneratorFacilityTypes["seat"] = "seat";
    QrGeneratorFacilityTypes["pets"] = "pets";
    QrGeneratorFacilityTypes["taxi"] = "taxi";
    QrGeneratorFacilityTypes["train"] = "train";
    QrGeneratorFacilityTypes["coffee"] = "coffee";
    QrGeneratorFacilityTypes["dining"] = "dining";
    QrGeneratorFacilityTypes["parking"] = "parking";
    QrGeneratorFacilityTypes["restrooms"] = "restrooms";
    QrGeneratorFacilityTypes["loadingbay"] = "loadingbay";
    QrGeneratorFacilityTypes["wheelchair"] = "wheelchair";
    QrGeneratorFacilityTypes["restingarea"] = "restingarea";
})(QrGeneratorFacilityTypes = exports.QrGeneratorFacilityTypes || (exports.QrGeneratorFacilityTypes = {}));
var QrGeneratorSocialMediaBannerStyles;
(function (QrGeneratorSocialMediaBannerStyles) {
    QrGeneratorSocialMediaBannerStyles["STYLE1"] = "style1";
    QrGeneratorSocialMediaBannerStyles["STYLE2"] = "style2";
    QrGeneratorSocialMediaBannerStyles["STYLE3"] = "style3";
})(QrGeneratorSocialMediaBannerStyles = exports.QrGeneratorSocialMediaBannerStyles || (exports.QrGeneratorSocialMediaBannerStyles = {}));
var QrGeneratorFrameTypes;
(function (QrGeneratorFrameTypes) {
    QrGeneratorFrameTypes["STYLE1"] = "style1";
    QrGeneratorFrameTypes["STYLE2"] = "style2";
    QrGeneratorFrameTypes["STYLE3"] = "style3";
    QrGeneratorFrameTypes["STYLE4"] = "style4";
    QrGeneratorFrameTypes["STYLE5"] = "style5";
    QrGeneratorFrameTypes["STYLE6"] = "style6";
})(QrGeneratorFrameTypes = exports.QrGeneratorFrameTypes || (exports.QrGeneratorFrameTypes = {}));
